import React from 'react';


import {
    Cards,
    CardsPropertyFiltering,
    Button,
    CardsPagination, Spinner,
    Icon
} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';

const cardDefinition = {
    // header: item => item.name,
    sections: [
        {
            id: "eventId",
            width: 50,
            header: item => "Flow Id",
            content: item => item.eventId == "null" ? "Not created." : item.eventId
        },
        {
            id: "invoiceId",
            width: 50,
            header: item => "Entity Id",
            content: item => item.invoiceId
        },
        {
            id: "isAnomaly",
            width: 50,
            header: item => "Outlier",
            content: (item) => <span><Icon
                name={item.isAnomaly == null ? "status-in-progress" : (item.isAnomaly ? "bug" : "status-positive")}
                variant={item.isAnomaly ? "error" : "success"}/></span>,
        },
        {
            id: "anomalyReason",
            width: 50,
            header: item => "Outlier Reason",
            content: item => item.anomalyReason
        }
    ]
};

const cardsPerRow = [
    {
        "cards": 1
    },
    {
        "minWidth": 500,
        "cards": 1
    }
];

export class HeaderCard extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            searchLoadDone: false,
            reports: [],
            searchId: props.searchId
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getReportsResultHandler = this.getReportsResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            this.client.getReports({
                searchId: this.state.searchId,
            }, this.getReportsResultHandler);
        });
    }

    componentWillMount() {
        // this.client = new JSClient({onReady: this.clientLoaded});
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if (!objectCompare(this.state.props, nextProps)) {
    //         this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
    //     }
    // }
    //
    // componentWillUpdate(nextProps, nextState, nextContext) {
    //     if (!nextState.taskLoadDone)
    //         this.client.getTasks({
    //             type: nextState.type,
    //             user: nextState.user, ...nextProps
    //         }, this.getTasksResultHandler);
    // }

    getReportsResultHandler(searchResult) {
        this.setState({reports: searchResult.reports, searchLoadDone: true});
    }

    headerCounter(items) {
        return items.length;
    }

    render() {

        return (
            <div>

                <div>

                    <Cards
                        cardDefinition={cardDefinition}
                        items={this.props.data}
                        cardsPerRow={cardsPerRow}
                        loadingText="Loading resources"
                        wrapLines={false}
                        empty={<div className="awsui-util-t-c">
                            <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                <b>
                                    No resources
                                </b>
                            </div>
                            <p className="awsui-util-mb-s">
                                No resources to display
                            </p>
                            <div className="awsui-util-mb-m">
                                <Button text="Create resource"></Button>
                            </div>
                        </div>}
                        noMatch={<div className="awsui-util-t-c">
                            <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                <b>
                                    No matches
                                </b>
                            </div>
                            <p className="awsui-util-mb-s">
                                We can’t find a match.
                            </p>
                            <div className="awsui-util-mb-m">
                                <Button text="Clear filter"></Button>
                            </div>
                        </div>}
                    >
                    </Cards>
                </div>
            </div>


        );
    }
}




// WEBPACK FOOTER //
// ./src/components/cards/header_card.jsx